import React, { useState } from 'react';

const AdminPanel = () => {
  const [admins, setAdmins] = useState([
    { id: 1, name: 'John Doe', role: 'Super Admin', status: 'Active' },
    { id: 2, name: 'Jane Smith', role: 'Admin', status: 'Inactive' },
    { id: 3, name: 'Michael Johnson', role: 'Admin', status: 'Active' },
  ]);

  const handleAddAdmin = () => {
    const newAdmin = { id: admins.length + 1, name: 'New Admin', role: 'Admin', status: 'Active' };
    setAdmins([...admins, newAdmin]);
  };

  const handleRemoveAdmin = (id) => {
    setAdmins(admins.filter(admin => admin.id !== id));
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: '#fb9678' }}>Admin Panel</h1>
      <p>Manage all registered admins in the system.</p>
      <button
        onClick={handleAddAdmin}
        style={{
          backgroundColor: '#fb9678',
          color: '#fff',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
          fontWeight: 'bold',
          marginBottom: '20px',
        }}
      >
        Add New Admin
      </button>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
        <thead>
          <tr style={{ backgroundColor: '#fb9678', color: '#fff' }}>
            <th style={{ padding: '10px', textAlign: 'left' }}>Name</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Role</th>
            <th style={{ padding: '10px', textAlign: 'left' }}>Status</th>
            <th style={{ padding: '10px', textAlign: 'center' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {admins.map(admin => (
            <tr key={admin.id}>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{admin.name}</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{admin.role}</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>{admin.status}</td>
              <td style={{ padding: '10px', textAlign: 'center', border: '1px solid #ddd' }}>
                <button
                  onClick={() => handleRemoveAdmin(admin.id)}
                  style={{
                    backgroundColor: '#fb9678',
                    color: '#fff',
                    border: 'none',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                  }}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminPanel; 